import { useState, useContext, useEffect } from "react"
import _ from "lodash"
import { gql, useQuery } from "@apollo/client"

import { Field } from "formik"

import { MultiSelect } from "primereact/multiselect"

import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function StaffIds({ field, block, index }) {
  const [staffList, setStaffList] = useState([])
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GET_STAFF = gql`
    query getStaffIdsList($staff_id: ID!, $organization_id: ID!) {
      staffsByOrganization: staffMembersByOrganization(
        staff_id: $staff_id
        organization_id: $organization_id
      ) {
        staff_id
        staff_name_first
        staff_name_last
      }
    }
  `

  const { loading } = useQuery(GET_STAFF, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: !userCtx,
    onCompleted: ({ staffsByOrganization }) => {
      setStaffList(
        _.map(staffsByOrganization, (staff) => {
          return {
            label: `${staff.staff_name_first} ${staff.staff_name_last}`,
            key: staff.staff_id,
          }
        })
      )
    },
  })

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => (
            <>
              <MultiSelect
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                options={staffList}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
